import type { ComponentPropsWithRef } from 'react'

import classNames from 'classnames'

export const H1: React.FC<ComponentPropsWithRef<'h1'>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <h1 className={classNames('type-h-page-sm', className)} {...props}>
      {children}
    </h1>
  )
}
